import { composeBundles, createUrlBundle } from 'redux-bundler';
import boards from 'root/stores/boards';
import errors from 'root/stores/errors';
import extraArgs from 'root/stores/extra-args';
import fresh from 'root/stores/fresh';
import logrocket from 'root/stores/logrocket';
import notifications from 'root/stores/notifications';
import organizations from 'root/stores/organizations';
import routes from 'root/stores/routes';
import teams from 'root/stores/teams';
import theme from 'root/stores/theme';
import ui from 'root/stores/ui';
import user from 'root/stores/user';

export default composeBundles(
  boards,
  createUrlBundle,
  errors,
  extraArgs,
  fresh,
  logrocket,
  notifications,
  organizations,
  routes,
  teams,
  theme,
  ui,
  user,
);
